import React, { useEffect } from "react";
import TablePagination from "@material-ui/core/TablePagination";

export default function PaginationControlled ({
  tableLength = 1,
  updateRowCount,
  rowsPerPageOptions = [25, 50, 75, 100],
  pageNo,
  rowsPerPagination,
  parentKey=""
}) {
  const [page, setPage] = React.useState(pageNo);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPagination);

  /** customizes the instance value that is exposed to parent components */
  useEffect(() => {
    setPage(pageNo);
  }, [pageNo]);

  useEffect(() => {
    setRowsPerPage(rowsPerPagination);
  }, [rowsPerPagination]);

  /**
   * onchange page event 
   * @param {*} event 
   * @param {*} newPage 
   */
  function handleChangePage (event, newPage) {
    updateRowCount(newPage, rowsPerPage);
  }

  /** handle changes per page update row count */
  function handleChangeRowsPerPage (event) {
    const perPage = parseInt(event.target.value, 10);
    updateRowCount(0, perPage);
  }

  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      key={parentKey+"tablePagination"}
      component={"div"}
      count={tableLength}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      //onchange
    />
  );
}
